




















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PasswordInput extends Vue {
  @Prop() readonly value!: string | number | boolean;
  @Prop({ default: "" }) readonly id!: string;
  @Prop({ default: "" }) readonly placeholder!: string;
  @Prop({ default: "" }) readonly label!: string;
  @Prop({ default: false }) readonly hasError!: boolean;
  @Prop({ default: "" }) readonly error!: string;
  @Prop({ default: false }) readonly hideErrorText!: boolean;
  @Prop({ default: false }) readonly isDisabled!: boolean;
  @Prop({ default: "" }) readonly icon!: string;

  get hasIcon(): boolean {
    return this.icon.length > 0;
  }
}
